// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"482":"3bdda3641a6f00ab0eee","655":"97be49166a589c039c88"}[chunkId] + ".js";
};